import { jsx as e, jsxs as m } from "react/jsx-runtime";
import { useMemo as u } from "react";
function f({
  cn: a,
  ariaDescribedBy: l,
  closeIconSlot: c,
  openIconSlot: p,
  isHidden: r,
  onClick: n,
  iconUrl: s,
  iconMask: o,
  iconSize: t,
  openByDefault: i
}) {
  const h = u(
    () => ({
      width: t,
      height: t
    }),
    [t]
  );
  return /* @__PURE__ */ e(
    "div",
    {
      className: "flex items-center gap-2.5",
      "data-open-by-default": i,
      children: /* @__PURE__ */ e(
        "button",
        {
          "aria-describedby": l,
          type: "button",
          onClick: n,
          style: h,
          className: a(
            "chatbot-icon-button flex cursor-pointer items-center justify-center overflow-hidden bg-primary text-primary-foreground shadow-[0_5px_10px_0_rgba(0,_0,_0,_0.2)] transition-all hover:shadow-[0_5px_10px_0_rgba(0,_0,_0,_0.3)]",
            {
              "rounded-none": o === "square",
              "rounded-xl": o === "squircle",
              "rounded-full": o === "circle"
            }
          ),
          children: /* @__PURE__ */ m("span", { className: "grid place-items-center [&>*]:col-span-full [&>*]:row-span-full", children: [
            /* @__PURE__ */ e(
              "span",
              {
                style: { width: t, height: t },
                className: a(
                  "flex items-center justify-center transition-opacity",
                  {
                    "opacity-0": r,
                    "opacity-100": !r
                  }
                ),
                children: /* @__PURE__ */ e(c, {})
              }
            ),
            s ? /* @__PURE__ */ e(
              "img",
              {
                className: a("object-cover transition-opacity", {
                  "opacity-0": !r,
                  "opacity-100": r
                }),
                src: s,
                alt: "Embed icon",
                width: t + "px",
                height: t + "px"
              }
            ) : /* @__PURE__ */ e(
              "span",
              {
                style: { width: t, height: t },
                className: a(
                  "flex items-center justify-center transition-opacity",
                  {
                    "opacity-0": !r,
                    "opacity-100": r
                  }
                ),
                children: /* @__PURE__ */ e(p, {})
              }
            )
          ] })
        }
      )
    }
  );
}
export {
  f as EmbedIcon
};
